import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    socket: {
      achievements: [],
      isConnected: false,
      message: '',
      reconnectError: false,
      onlineUsers: {},
      platformUsers: {},
      upgradePlanRes: {}
    },
    quicksightPlatforms: ['sem-parar', 'sem-parar+', 'bike-registrada', 'pneustore-chatflow', 'serena', 'monte-carlo', 'demo'],
  },
  getters: {
    quicksightPlatforms: (state) => state.quicksightPlatforms,
  },
  mutations: {
    SOCKET_ONOPEN(state, event) {
      Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true
    },
    SOCKET_ONCLOSE(state, event) {
      state.socket.isConnected = false
      state.socket.onlineUsers = {};
    },
    SOCKET_ONERROR(state, event) {
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      //console.log(message);
      state.socket.message = message;

      if(message.message.action == 'achievements' && message.message.achievements.length) {
        //state.socket.achievements = message.message.achievements;
        //console.log(message.message.achievements);
        localStorage.setItem('achievements', JSON.stringify(message.message.achievements));
      }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    },
    SOCKET_PLATFORM_USERS(state, users) {
      state.socket.platformUsers = users;
    }
  },
  actions: {
    socketSendMessage: (context, message) => {
      Vue.prototype.$socket.sendObj(message);
    },
    socketUpgradePlanRes: (context, message) => {
      context.state.socket.upgradePlanRes = message;
    },
    socketOnlineUsers: (context, message) => {
      context.state.socket.onlineUsers = {};
      for (const user of message.body) {
        context.state.socket.onlineUsers[user.user_id] = user;
      }
    },
    exportToPABXResponse: (context, message: { totalProcessed: number, errors: [any], responseStatus: { [key: string]: ExportStatus } }) => {

      context.commit("exportToPABX/decrementChunksAmount");

      context.commit("exportToPABX/incrementExportsCounterSuccess", message.totalProcessed - message.errors.length);

      for (let status in message.responseStatus) {
        if (!context.getters["exportToPABX/isStatusDefined"](status))
          context.commit("exportToPABX/defineExportStatus", { key: status, value: message.responseStatus[status] });
        else {
          context.commit("exportToPABX/incrementExportStatusAmount", { status: status, amount: message.responseStatus[status].amount });
        }
      }

      context.commit("exportToPABX/incrementExportsCounterError", message.errors.length);
      context.commit("exportToPABX/incrementExportStatusAmount", { status: "pabxWsError", amount: message.errors.length });
    }
  },
  modules: {
    ...modules,

    exportToPABX: {
      namespaced: true,

      state: () => ({
        chunksAmount: 0,
        exportsCounter: {
          total: 0,
          success: 0,
          error: 0
        },
        exportsStatus: {
          pabxWsError: {
            amount: 0,
            description: "Erro na chamada do WebService do PABX"
          },
          msError: {
            amount: 0,
            description: "Erro na chamada do microserviço"
          }
        }
      }), // module state is already nested and not affected by namespace option

      getters: {
        chunksAmount: (state) => {
          return state.chunksAmount
        },
        exportInProgress(state) {
          let counter = state.exportsCounter;
          return counter.total != counter.success + counter.error;
        },
        isStatusDefined: (state) => (statusName) => {
          return state.exportsStatus.hasOwnProperty(statusName);
        },
        exportsCounter(state) {
          return state.exportsCounter;
        },
        exportsStatus: (state) => {
          return state.exportsStatus;
        }
      },

      actions: {},

      mutations: {
        setChunksAmount(state, value) {
          state.chunksAmount = value;
        },
        decrementChunksAmount(state) {
          state.chunksAmount--;
        },
        clearExportProgress(state) {
          state.exportsCounter.total = 0;
          state.exportsCounter.success = 0;
          state.exportsCounter.error = 0;
          for (let status in state.exportsStatus)
            state.exportsStatus[status].amount = 0;
        },
        setExportsCounterTotal(state, value) {
          state.exportsCounter.total = value;
        },
        incrementExportsCounterTotal(state, value = 1) {
          state.exportsCounter.total += value;
        },
        incrementExportsCounterSuccess(state, value = 1) {
          state.exportsCounter.success += value;
        },
        incrementExportsCounterError(state, value = 1) {
          state.exportsCounter.error += value;
        },
        defineExportStatus(state, status: { key: string, value: ExportStatus }) {
          state.exportsStatus[status.key] = status.value;
        },
        incrementExportStatusAmount(state, data: { status: string, amount?: number }) {
          if (data.amount !== 0)
            state.exportsStatus[data.status].amount += data.amount || 1;
        }
      },
    },

    navBarAlert: {
      namespaced: true,

      state: () => ({
        successAlertMessage: '',
        showSuccessAlert: 0,
        dangerAlertMessage: '',
        showDangerAlert: 0,
        warningAlertMessage: '',
        showWarningAlert: 0
      }),

      getters: {
        successAlertMessage: (state) => {
          return state.successAlertMessage;
        },
        showSuccessAlert: (state) => {
          return state.showSuccessAlert;
        },
        warningAlertMessage: (state) => {
          return state.warningAlertMessage;
        },
        showWarningAlert: (state) => {
          return state.showWarningAlert;
        },
        dangerAlertMessage: (state) => {
          return state.dangerAlertMessage;
        },
        showDangerAlert: (state) => {
          return state.showDangerAlert;
        }
      },

      mutations: {
        SUCCESS_ALERT(state, message) {
          state.successAlertMessage = message;
          state.showSuccessAlert = 10;
        },
        SUCCESS_ALERT_COUNTDOWN(state, secsUntilDismiss) {
          state.showSuccessAlert = secsUntilDismiss;
        },
        SUCCESS_ALERT_DISMISS(state) {
          state.successAlertMessage = '';
          state.showSuccessAlert = 0;
        },
        WARNING_ALERT(state, message) {
          state.warningAlertMessage = message;
          state.showWarningAlert = 10;
        },
        WARNING_ALERT_COUNTDOWN(state, secsUntilDismiss) {
          state.showWarningAlert = secsUntilDismiss;
        },
        WARNING_ALERT_DISMISS(state) {
          state.warningAlertMessage = '';
          state.showWarningAlert = 0;
        },
        DANGER_ALERT(state, message) {
          state.dangerAlertMessage = message;
          state.showDangerAlert = 10;
        },
        DANGER_ALERT_COUNTDOWN(state, secsUntilDismiss) {
          state.showDangerAlert = secsUntilDismiss;
        },
        DANGER_ALERT_DISMISS(state) {
          state.dangerAlertMessage = '';
          state.showDangerAlert = 0;
        }
      },

      actions: {}
    },

    commission: {
      namespaced: true,

      state: () => ({
        hideCommission: true
      }),

      getters: {
        hideCommission: (state) => {
          return state.hideCommission;
        },
      },

      actions: {},

      mutations: {
        HIDE_COMMISSION(state, hide) {
          state.hideCommission = hide;
        },
      },
    },

    leadList: {
      namespaced: true,

      state: () => ({
        listedPhones: [] as string[],                          // Phones on the lead list
        updatedLeadExportLabel: null as LeadExportLabel|null   // Message that cames from websocket when an attendant sends a WhatsApp message
      }),

      getters: {
        listedPhones: (state) => {
          return state.listedPhones;
        },
        updatedLeadExportLabel: (state) => {
          return state.updatedLeadExportLabel;
        },
      },

      actions: {
        updateLeadExportLabel: (context, message: LeadExportLabel) => {
          if (context.getters["listedPhones"].includes(message.phone)) {
            context.commit("UPDATE_LEAD_EXPORT_LABEL", message);
          }
        }
      },

      mutations: {
        UPDATE_LEAD_EXPORT_LABEL(state, updatedData) {
          state.updatedLeadExportLabel = updatedData;
        },

        LISTED_PHONES(state, phonesArray: string[]) {
          state.listedPhones = phonesArray;
        }
      },
    }
  }
})

interface ExportStatus {
  description: string,
  amount: number
}

interface LeadExportLabel {
  phone: string,
  text: string
}
